import React from 'react'
import PropTypes from 'prop-types'
import {Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'

/**
 * A functional React component that renders a note indicating mandatory fields in a form.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {string} [props.align='right'] - Specifies the text alignment for the note.
 *                                         Defaults to 'right'.
 * @returns {JSX.Element} A JSX element containing a text note that indicates required fields.
 *
 * @example
 * // Renders a mandatory note aligned to the left
 * <MandatoryNote align="left" />
 *
 * @example
 * // Renders a mandatory note with default alignment (right)
 * <MandatoryNote />
 *
 * @remarks
 * This component uses the `FormattedMessage` component from `react-intl` to support
 * internationalization, allowing the message to be translated into different languages.
 */
const MandatoryNote = ({align = 'right'}) => {
    return (
        <Text textAlign={align} variant="bodyXSmall" color="darkGray">
            <FormattedMessage
                defaultMessage="*Required fields"
                id="mandatory_note.required_fields"
            />
        </Text>
    )
}

MandatoryNote.propTypes = {
    align: PropTypes.string
}

export default MandatoryNote
